export const SEARCH_ALL_QUESTIONS = 'SEARCH_ALL_QUESTIONS';
export const SEARCH_UNANS_QUESTIONS = 'SEARCH_UNANS_QUESTIONS';
export const GET_ANWSER = 'GET_ANWSER';
export const GET_QUESTION = 'GET_QUESTION';
